import { useTranslation } from "react-i18next";
import HomeIcon from "../../assets/Icon/HomeIcon.svg";
import ServiceIcon from "../../assets/Icon/ServiceIcon.svg";
import AdvisoryIcon from "../../assets/Icon/AdvisoryIcon2.svg";
import PersonIcon from "../../assets/Icon/PersonIcon.svg";
import AudienceIcon from "../../assets/Icon/AudienceIcon.svg";
import DeadlineIcon from "../../assets/Icon/DeadlineIcon.svg";

const BottomFarmernavItems = (role) => {
  const { t } = useTranslation();

  const farmerNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    // {
    //   label: t("Service"),
    //   to: "/service/farmer",
    //   icon: ServiceIcon,
    // },
    // {
    //   label: t("Advisory"),
    //   to: "/farmer/advisory",
    //   icon: AdvisoryIcon,
    // },
    {
      label: t("Profile"),
      to: "/farmer/profile",
      icon: PersonIcon,
    },
  ];

  const fpoNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Service"),
      to: "/service/fpo",
      icon: ServiceIcon,
    },
    {
      label: t("Farmers"),
      to: "fpo/farmers",
      icon: PersonIcon,
    },
    {
      label: t("Loan"),
      to: "fpo/loans",
      icon: AdvisoryIcon,
    },
  ];
  const sponsortNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Profile"),
      to: "#",
      icon: PersonIcon,
    },
  ];

  const buyerNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Service"),
      to: "/service/buyer",
      icon: ServiceIcon,
    },
    {
      label: t("Programs"),
      to: "/programs/",
      icon: AdvisoryIcon,
    },
    {
      label: t("Profile"),
      to: "/buyer/details",
      icon: PersonIcon,
    },
  ];

  const agroExpertNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Profile"),
      // to: "/",
      icon: PersonIcon,
    },
  ];

  const popManagerNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Programs"),
      to: "/pop-manager/programs-list",
      icon: ServiceIcon,
    },
    {
      label: t("Projects"),
      to: "/area-project-list",
      icon: DeadlineIcon,
    },
    {
      label: t("Area Managers"),
      to: "/pop-manager/area-managers",
      icon: AudienceIcon,
    },
    {
      label: t("Profile"),
      // to: "/",
      icon: PersonIcon,
    },
  ];

  const areaManagerNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Programs"),
      to: "/area-manager/programs",
      icon: ServiceIcon,
    },
    {
      label: t("VLEs"),
      to: "/area-manager/vles",
      icon: AudienceIcon,
    },
    {
      label: t("Profile"),
      // to: "/",
      icon: PersonIcon,
    },
  ];

  const vleNavItems = [
    {
      label: t("Home"),
      to: `/`,
      icon: HomeIcon,
    },
    {
      label: t("Programs"),
      to: "/vle/programs",
      icon: ServiceIcon,
    },
    {
      label: t("Farmers"),
      to: "/farmers-list",
      icon: AudienceIcon,
    },
    {
      label: t("Verification Tasks"),
      to: "/vle/verification-tasks",
      icon: ServiceIcon,
    },
  ];

  if (role === "FARMER") return farmerNavItems;
  if (role === "FPO") return fpoNavItems;
  if (role === "SPONSOR") return sponsortNavItems;
  if (role === "BUYER") return buyerNavItems;
  if (role === "AGRO_EXPERT") return agroExpertNavItems;
  if (role === "POP_MANAGER") return popManagerNavItems;
  if (role === "AREA_MANAGER") return areaManagerNavItems;
  if (role === "VLE") return vleNavItems;
};

export default BottomFarmernavItems;
